import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly zone = inject(NgZone);
  private readonly router = inject(Router);
  private readonly loader = inject(NgxUiLoaderService, { optional: true });
  private isNavigating = false;

  handleError(error: unknown): void {

    if (error instanceof HttpErrorResponse) {
      return;
    }

    const errStr = String((error as any)?.message || (error as any)?.reason || error || '');
    if (errStr.includes('ResizeObserver loop completed with undelivered notifications') || errStr.includes('ResizeObserver loop limit exceeded')) {
      return;
    }

    if (this.loader) {
      try {
        this.loader.stopAll();
      } catch (e) {
        console.warn('Could not stop all UI loaders:', e);
      }
    }

    if (this.isNavigating) {
      return;
    }

    this.isNavigating = true;

    let errorMessage = 'An unexpected runtime error occurred.';
    let errorStack = '';

    if (error instanceof Error) {
      errorMessage = error.message;
      errorStack = error.stack ?? '';
    } else if (error && typeof error === 'object') {
      try {
        errorMessage = (error as any).message ?? JSON.stringify(error);
      } catch {
        errorMessage = String(error);
      }
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    this.zone.run(() => {
      this.router.navigate(['/error'], {
        state: { message: errorMessage, stack: errorStack },
        skipLocationChange: true,
      }).then(
        (navigated) => {
          this.isNavigating = false;
          if (!navigated) {
            console.error('Navigation to /error was rejected/cancelled.');
          }
        },
        (navError) => {
          this.isNavigating = false;
          console.error('Failed to navigate to error page:', navError);
        }
      );
    });
  }
}
